import { useEffect, useState, useCallback } from 'react';

import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import Grid from '@mui/material/Grid';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

const distances = [
    '5', '10', '25', '50'
];

const FilterTowerDistance = ({ searchMarker, towerFilters, setTowerFilters }) => {
    const [open, setOpen] = useState(false);
    const [selectedDistance, setSelectedDistance] = useState(towerFilters['distance']);
    //const [filteredDistance, setFilteredDistance] = useState('');

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedDistance(value);
        setOpen(true);
    };

    const handleClose = (event) => {
        if (event.target.type !== 'radio') {
            if (selectedDistance !== towerFilters.distance) setSelectedDistance(towerFilters.distance);
            setOpen(false);
        }
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const handleApplyClick = (e) => {
        let v = { distance: (selectedDistance === "0" ? null : selectedDistance) };
        setTowerFilters(towerFilters => ({ ...towerFilters, ...v }));
        setOpen(false);
    };

    const handleClearClick = useCallback(() => {
        let v = { distance: null };
        setTowerFilters(towerFilters => ({ ...towerFilters, ...v }));
        setOpen(false);
    }, [setTowerFilters]);

    useEffect(() => {
        if (searchMarker === null) handleClearClick();
    }, [searchMarker, handleClearClick])

    useEffect(() => {
        setSelectedDistance(towerFilters.distance === null ? '' : towerFilters.distance)
    }, [towerFilters.distance])

    return (

        <FormControl sx={{ m: 1, width: 155, background: 'whitesmoke' }} size="small">
            <InputLabel id="distance-label">Tower Distance</InputLabel>
            <Select
                labelId="distance-label"
                value={selectedDistance === null ? '' : selectedDistance}
                onClose={handleClose}
                onOpen={handleOpen}
                input={<OutlinedInput label="Tower Distance" />}
                renderValue={(selected) => selected + " Miles"}
                disabled={searchMarker === null}
                open={open}
            >

                <RadioGroup
                    onChange={handleChange}
                    value={selectedDistance}
                >

                    {distances.map((distance) => (
                        <MenuItem value={distance} dense={true} key={distance} >
                            <FormControlLabel value={distance} control={<Radio size="small" checked={selectedDistance === distance} />} label={distance + " Miles"} />
                        </MenuItem>
                    ))}

                </RadioGroup>

                <Grid
                    m={1}
                    display="flex"
                    justifyContent="flex-end"
                    alignItems="flex-end"
                >
                    <Box pr={1}>
                        <Button disabled={towerFilters.distance === null}  size="small" variant="text" onClick={handleClearClick}>Clear</Button>
                    </Box>
                    <Box>
                        <Button size="small" variant="contained" onClick={handleApplyClick}>Apply</Button>
                    </Box>
                </Grid>

            </Select>
        </FormControl>
    );
}

export default FilterTowerDistance;